

















import { Component, Vue } from "vue-property-decorator";

@Component({
    components: {
        BlogCard: () => import("./card.vue")
    }
})
export default class BlogPage extends Vue {
    loading: boolean = false;

    params: BlogParams = { per_page: 99, page: 1 };

    articles: Article[] = [];

    private mounted() {
        this.getArticles();
    }

    private getArticles() {
        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/articles", { params: { ...this.params } })
            .then((response: any) => (this.articles = response.data.data))
            .finally(() => (this.loading = false));
    }
}
